<script lang="ts">
  import { CheckVerified } from './icons';
</script>

<div class="badge">
  <span class="icon">
    <CheckVerified />
  </span>
  Satisfaction Guaranteed
</div>

<style lang="scss">
  .badge {
    display: inline-flex;
    align-items: center;
    gap: var(--spacing-nano);
    width: fit-content;
    height: fit-content;
    padding: var(--spacing-atom) var(--spacing-mini);
    border-radius: 50px;
    background: var(--color-neutralWhite);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    color: var(--color-pallette-neutralBlack, #111);
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.16px;
  }

  .icon {
    display: flex;
    color: var(--vlt-lp-accent);
  }
</style>
